import React, { createContext, useState } from 'react';

export const ModalStateContext = createContext<React.ReactNode>(null);
export const ModalDispatchContext = createContext<React.Dispatch<React.SetStateAction<React.ReactNode>>>(() => null);

type Props = {
  children: React.ReactNode;
};

const ModalProvider: React.FC<Props> = ({ children }) => {
  const [modal, setModal] = useState<React.ReactNode>(null);
  return (
    <ModalStateContext.Provider value={modal}>
      <ModalDispatchContext.Provider value={setModal}>{children}</ModalDispatchContext.Provider>
    </ModalStateContext.Provider>
  );
};

export default ModalProvider;
